import { Component, OnDestroy, OnInit } from "@angular/core";
import { Subject, takeUntil } from "rxjs";
import { QuizModuleService } from "../../quiz-module.service";
import { UserLeague } from "@core/models/user-league";
import { AuthenticationService } from "@core/services/auth";
import { User } from "@core/models";

@Component({
  standalone: false,
  selector: "app-quiz-leaderboard-move",
  templateUrl: "./quiz-leaderboard-move.component.html",
  styleUrls: ["./quiz-leaderboard-move.component.scss"],
})
export class QuizLeaderboardMoveComponent implements OnInit, OnDestroy {
  private unsubscribe$ = new Subject<boolean>();
  isLoading = true;
  leagueMembers: UserLeague[];
  userLeagueDetails: UserLeague;
  userId: number;
  currentLeagueIndex: number;
  dataTableLeagueData: UserLeague[];
  rankingLeagueData: UserLeague[];
  leagueLevels = ["Bronze", "Silver", "Gold", "Platinum"];
  currentUser: User;

  constructor(
    private quizService: QuizModuleService,
    private authService: AuthenticationService
  ) {}

  ngOnInit(): void {
    this.currentUser = this.authService.currentUserValue;
    this.getUserLeague();
  }

  getUserLeague(): void {
    this.quizService
      .getUserLeague()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: (res) => {
          this.userLeagueDetails = res;
          this.userId = this.userLeagueDetails.userId;
          this.getLeagueMembers(res.leagueId, res.type);
          this.currentLeagueIndex = this.leagueLevels.indexOf(
            this.userLeagueDetails.leagueLevelTitle
          );
        },
        error: (err) => {
          console.log(err);
        },
      });
  }

  getLeagueMembers(leagueId: number, leagueType: string): void {
    this.isLoading = true;
    this.quizService
      .getLeagueMembers(leagueId, leagueType)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: (res) => {
          this.isLoading = false;
          this.leagueMembers = res.splice(17);
          this.dataTableLeagueData = this.leagueMembers.sort(
            (a, b) => b.weekPoints - a.weekPoints
          );
          this.rankingLeagueData = this.dataTableLeagueData;
          // this.customizeUserMessage();
        },
        error: (err) => {
          this.isLoading = false;
          console.log(err);
        },
      });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(true);
    this.unsubscribe$.unsubscribe();
  }
}
